import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyB3WlwfloAupy49X4Rhg_QI5yx-1aE5zxM",
  authDomain: "prm-core.firebaseapp.com",
  projectId: "prm-core",
  storageBucket: "prm-core.firebasestorage.app",
  messagingSenderId: "199753731452",
  appId: "1:199753731452:web:fcdbc8787c5eb4e5c0a8f9",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
